import React, { useState, useEffect, useContext } from "react";
import { Box, VStack, Heading, Button, Icon } from "@chakra-ui/react";
import { AiOutlineWhatsApp } from "react-icons/ai";
import Select from "react-select";
import LabeledText from "../../Common/Layout/LabeledText";
import ContentCard from "../../Common/Layout/ContentCard";
import { OrdersContext } from "../../Context/OrdersContext";
import { arrayToOption } from "../../../Utils/formatUtils";
import moment from "moment";
import ConfirmationSwal from "../../../Utils/confirmationSwal";
import { currencyFormatter } from "../../../Utils/formatUtils";
import { UsersContext } from "../../Context/UsersContext";
import { userIsAllowed } from "../../../Utils/userIsAllowed";

const OrderData = ({
  order,
  setNewStatus,
  updatePrints,
  updateConfirmation,
}) => {
  const { getAllStatus } = useContext(OrdersContext);
  const { currentUser } = useContext(UsersContext);
  const [statusOptions, setStatusOptions] = useState([]);
  const [billingPrintSelected, setBillingPrintSelected] = useState({
    value: 1,
    label: "template A",
  });
  const printsOptions = [{ value: 1, label: "template A" }];

  const parseData = async () => {
    //TODO: make only one call to get status
    const allStatus = await getAllStatus();
    let statusFiltered = [];
    if (order.statusId < 3) {
      statusFiltered = allStatus.filter((stat) => stat.id <= 3);
    } else {
      if (
        userIsAllowed(currentUser, [5]) ||
        (userIsAllowed(currentUser, [6]) && order.statusId < 4)
      ) {
        statusFiltered = allStatus;
      } else if (userIsAllowed(currentUser, [6]) && order.statusId >= 4) {
        statusFiltered = allStatus.filter((stat) => stat.id >= 4);
      } else if (userIsAllowed(currentUser, [7])) {
        statusFiltered = allStatus.filter((stat) => stat.id >= order.statusId);
      }
    }
    let options = arrayToOption(statusFiltered);
    setStatusOptions(options);
  };

  const getOrderTotal = () => {
    const totalOrder = order.products.reduce((total, item) => {
      const itemPriceWithDiscount = item.price * (1 - item.discount / 100);
      const itemTotal = itemPriceWithDiscount * item.qty;
      return total + itemTotal;
    }, 0);
    return totalOrder;
  };

  useEffect(() => {
    parseData();
  }, [order]);

  const handleChange = async (value) => {
    if (value.value != order.statusId) {
      let text = ` ¿Desea cambiar el estado de ${
        statusOptions.length &&
        statusOptions.find((option) => option.value == order.statusId).label
      } a ${value.label}?`;

      ConfirmationSwal.fire({
        title: "Cambio de estado",
        text: text,
        icon: "question",
        confirmButtonText: "Cambiar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setNewStatus(value.value);
        }
      });
    }
  };

  const printBilling = () => {
    updatePrints();
    window.open(`/pedidos/${order.id}/facturas`);
  };

  const getWhatsappLink = () => {
    let text = "";
    const button = (isConfirmation = false) => {
      return (
        <Button
          fontSize="0.8em"
          isDisabled={!isConfirmation}
          onClick={() => {
            isConfirmation && updateConfirmation();
            window.open(
              `https://wa.me/${order.phone}?text=${encodeURIComponent(text)}`
            );
          }}
        >
          <Icon
            _hover={{ cursor: "pointer" }}
            mx="2"
            as={AiOutlineWhatsApp}
            title={"Whatsapp"}
          ></Icon>
          {order.confirmations ? "Reenviar" : "Enviar"}
        </Button>
      );
    };

    // eslint-disable-next-line default-case
    switch (order.statusId) {
      case 3: //Confirmado
        text = "Tu pedido ha sido confirmado.";
        return button(true);
      case 4: //Armado
        text = "Tu pedido ya fue armado";
        return button();
      case 5: //Enviado
        text = "Tu pedido ya fue enviado";
        return button();
    }
  };

  return (
    <ContentCard w={["auto", "50%"]}>
      <Heading variant="h2">Información del Pedido</Heading>

      <VStack align="left" fontSize="0.9em">
        <Box>
          <LabeledText label="Nro. de pedido" text={order.id}></LabeledText>
        </Box>
        <LabeledText
          label="Estado"
          text={
            <VStack spacing="12px">
              <Box w={"100%"}>
                {userIsAllowed(currentUser, [3]) ? (
                  <Select
                    options={statusOptions}
                    value={statusOptions.find(
                      (option) => option.value === order.statusId
                    )}
                    onChange={handleChange}
                  />
                ) : (
                  statusOptions.find(
                    (option) => option.value === order.statusId
                  )?.label
                )}
              </Box>

              {getWhatsappLink()}
            </VStack>
          }
        ></LabeledText>

        <LabeledText
          label="Fecha Confirmación"
          text={
            order.confirmedAt
              ? moment(order.confirmedAt).format("DD-MM-YYYY HH:mm:ss")
              : "-"
          }
        ></LabeledText>
        <LabeledText
          label="Últ. cambio de estado"
          text={moment(order.statusUpdatedAt).format("DD-MM-YYYY HH:mm:ss")}
        ></LabeledText>
        <LabeledText
          label="Factura"
          text={
            <VStack spacing="12px">
              <Box w={"100%"}>
                <Select
                  options={printsOptions}
                  value={billingPrintSelected}
                  onChange={(e) => setBillingPrintSelected(e)}
                />
              </Box>
              <Button
                fontSize="0.8em"
                onClick={() => printBilling()}
                isDisabled={!order.confirmedAt}
              >
                {order.prints ? "Volver a imprimir" : "Imprimir"}
              </Button>
            </VStack>
          }
        ></LabeledText>
        <LabeledText
          label="Subtotal"
          text={`${currencyFormatter(getOrderTotal())}`}
        ></LabeledText>
      </VStack>
    </ContentCard>
  );
};

export default OrderData;
